import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import '../../styles/commentBox.scss';
import { Icon, Popup } from 'semantic-ui-react';

class FavoriteIcon extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.favoriteMe = this.favoriteMe.bind(this);
        this.unfavoriteMe = this.unfavoriteMe.bind(this);
    }

    getInitialState() {
        return {
            isFavorite: this.props.isFavorite
        }
    }

    favoriteMe() {

        let recordId = this.props.recordId;
        let userId = this.props.userId;

        let self = this;

        Flagship.post(
            'favorite/' + recordId + '/' + userId,
            {},
            function(response) {
                if (response.data.success === true) {
                    self.setState({
                       isFavorite: true
                    });
                    Flagship.notify("Marked as favorite.", "success");

                } else {
                    Flagship.error("Failed to mark as favorite.", recordId, userId);
                }
            }
        );
    }

    unfavoriteMe() {

        let recordId = this.props.recordId;
        let userId = this.props.userId;
        let self = this;
        Flagship.post(
            'unfavorite/' + recordId + '/' + userId,
            {},
            function (response) {
                if (response.data.success === true) {
                    self.setState({
                       isFavorite:false
                    });
                    Flagship.notify("Un-marked as favorite.");
                } else {
                    Flagship.error("Failed to un-mark as favorite.", recordId, userId);
                }
            }
        );
    }

    favoriteIcon() {
        if ( this.state.isFavorite ) {
            return (
                <Icon size="large" className="favorite-icon active" name="star" onClick={this.unfavoriteMe} />
            );
        } else {
            return (
                <Icon size="large" className="favorite-icon inactive" name="star" onClick={this.favoriteMe} />
            );
        }
    }

    render() {
        return (
            <Popup
                trigger={this.favoriteIcon()}
                position="bottom right"
                content={this.state.isFavorite ? "Click to remove from favorites." : "Click to mark as favorite."}
            />

        );
    }
}

FavoriteIcon.propTypes = {
    userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
      userId: state.main.userId,
  };
}


export default connect(
  mapStateToProps,
  null,
)(FavoriteIcon);





// WEBPACK FOOTER //
// ./src/components/records/FavoriteIcon.js